// extracted by mini-css-extract-plugin
module.exports = {"Right":"Right-module--Right--YiHp4"};